
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};

OCS.Viewer.Functions.define_layer_background_interface = function () {
    OCS.Viewer.Interfaces.LayerBackground = {
        background_draw_setup: function () {
            this.drawing_in_background = true;
            var source = this.get_source();
            if (source) {
                this.set_opacity(0.0);
                this.set_visible(true);
                source.changed();
            }
        },
        background_draw_finish: function () {
            this.drawing_in_background = false;
            this.set_visible(false);
            this.set_opacity(1.0);
        },
    };
};
OCS.Viewer.Functions.define_layer_background_interface();